// 🚨 GENERATED FILE - DO NOT EDIT DIRECTLY
export const BREAKPOINTS = {
  mobile: 0,
  tablet: 600,
  desktop: 1024,
  wide: 1440,
};
